import initialStore from './initialState'
import { IntegrationAction } from '../airbnb/actionNames'


export enum IntegrationStatus {
  NotIntegrated,
  Integrated,
}

export interface IBoxBuyIntegrationStore {
  status: IntegrationStatus
  loading: boolean
}

export default function(
  store: Readonly<IBoxBuyIntegrationStore> = initialStore,
  action: any,
): IBoxBuyIntegrationStore {
  switch (action.type) {
    case IntegrationAction.SetBoxBuyIntegration:
      return {
        ...store,
        status: action.payload,
      }
    case IntegrationAction.SetBoxBuyLoading:
      return { ...store, loading: action.payload }
  }
  return store
}

export interface IBoxBuyIntegrationStore {
  status: IntegrationStatus
}
